import { PricesMode } from '../../redux/config'
import { ContractType } from '../../redux/user'

export type PriceProps = {
  pricesMode: PricesMode
  contractType: ContractType
  grossValue?: string | number
  netValue?: string | number
}

export const Price = ({ pricesMode, contractType, grossValue, netValue }: PriceProps) => {
  switch (pricesMode) {
    case PricesMode.WithTaxInfo:
      return netValue?.toString()
    case PricesMode.DecideByContractType:
      return contractType === ContractType.PayperClick ? grossValue?.toString() : netValue?.toString()
    default:
      return grossValue?.toString()
  }
}
